import React from 'react'
import {TransProps} from '@lingui/react'
import { ArrowLeftIcon, MenuIcon } from '@heroicons/react/outline';
import { useHistory } from 'react-router-dom';
import { getColor } from 'components/utils';


// Type
export type typeHeaderDashboard = {
    variant?: string
    headerTitle: React.ReactElement<TransProps>
    setSidebarOpen: React.Dispatch<React.SetStateAction<boolean>>
    goBack?: boolean
}


// Component
export const HeaderDashboard: React.FC<typeHeaderDashboard> = ({variant,headerTitle, setSidebarOpen, goBack}) => {

    const history = useHistory()

    const color = getColor(variant)

    return(
        <div className="flex items-center gap-4">

            <div className="xl:hidden">
                <button
                    className="h-10 w-10 inline-flex items-center justify-center rounded-md text-gray-500 hover:text-gray-900 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500 border"
                    onClick={() => setSidebarOpen(true)}
                >
                    <span className="sr-only">Open sidebar</span>
                    <MenuIcon className="h-6 w-6" aria-hidden="true" />
                </button>
            </div>

            {goBack
                ? <button
                    className={`mr-2 h-10 w-10 inline-flex items-center justify-center rounded-md text-gray-500 hover:text-gray-900 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-${color}-500 border`}
                    onClick={() => history.goBack()}
                >
                    <span className="sr-only">Open sidebar</span>
                    <ArrowLeftIcon className="h-6 w-6" aria-hidden="true" />
                </button>
                : null
            }

            <h1 className="text-2xl font-semibold text-gray-900">{headerTitle}</h1>
        </div>
    )
}
